import {Controller} from '@hotwired/stimulus'
import CookieLanguageHelper from '../helpers/cookie_language_helper'

export default class extends Controller {
    static targets = ['table']

    connect() {
        this.initCheckboxes();
        this.initInputs();

        this.dt = $(this.tableTarget).DataTable({
            language: {url: CookieLanguageHelper.getTableTranslationFile()},
            paging: false,
            searching: false,
            info: false,
            columnDefs: [
                {orderSequence: ['desc', 'asc'], targets: '_all'},
                {type: 'num', targets: 6},
                {type: 'numeric-comma', targets: 5}
            ]
        });
    }

    disconnect() {
        this.dt.destroy();
    }

    initCheckboxes() {
        const selectAll = this.element.querySelector('#select-all');
        if (!selectAll) return;
        selectAll.addEventListener('change', () => {
            this.element.querySelectorAll('.row-select')
                .forEach(cb => (cb.checked = selectAll.checked))
        });
    }

    // After a Turbo (Rails) visit, inputs can lose their typed values.
    // This reapplies the original values from the HTML attributes.
    initInputs() {
        this.element.querySelectorAll('input[type="text"]').forEach(input => {
            const value = input.getAttribute('value')
            if (value) input.value = value
        })
    }
}
